import { render, staticRenderFns } from "./NumericHighlight.vue?vue&type=template&id=01887584&scoped=true&"
import script from "./NumericHighlight.vue?vue&type=script&lang=js&"
export * from "./NumericHighlight.vue?vue&type=script&lang=js&"
import style0 from "./NumericHighlight.vue?vue&type=style&index=0&id=01887584&lang=scss&scoped=true&"
import style1 from "./NumericHighlight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01887584",
  null
  
)

export default component.exports